export enum Level {
  BaseBottomLevel = 'base-bottom-level',
  BaseTopLevel = 'base-top-level',
  Ground = 'ground',
  Loft = 'loft',
  InteriorBuildingFloorLevel = 'interior-building-floor-level',
  PorchColumnTopLevel = 'porch-column-top-level',
  PorchColumnTopRightLevel = 'porch-column-top-right-level',
  PorchColumnTopLeftLevel = 'porch-column-top-left-level',
  PorchCeilingLevel = 'porch-ceiling-level',
  PorchRoofLevel = 'porch-roof-level',
  PorchFloorLevel = 'porch-floor-level',
  RoofLevel = 'roof-level',
  RoofPeakLevel = 'roof-peak-level',
  RoofStructureRafterLevel = 'roof-structure-rafter-level',
  RoofStructureBaseLevel = 'roof-structure-base-level',
  RoofStructureBaseTopLevel = 'roof-structure-base-top-level',
  RoofStructureBaseRightLevel = 'roof-structure-base-right-level',
  RoofStructureBaseLeftLevel = 'roof-structure-base-left-level',
  GableLevel = 'gable-level',
  RightWallTopLevel = 'right-wall-top-level',
  LeftWallTopLevel = 'left-wall-top-level',
  LegTopLevel = 'leg-top-level',
  LegBottomLevel = 'leg-bottom-level',
}
